module.exports = __webpack_public_path__ + "img/fundingProtectLogo1.bc559d4e.png";